import { put, select, takeLatest } from "redux-saga/effects";
import { triggerConfirmar, yes } from "./confirmationSlice";
import { isNotNull } from "../../core/helpers";

function* doConfirmar() {
    var cb = yield select ((state) => state.confirmation.cb)
    yield put(yes())

    if(isNotNull(cb)) {
        cb()
    }
}

export function* listenConfirmar() {
    yield takeLatest(triggerConfirmar, doConfirmar)
}